import { useEffect } from 'react';
import { useRouterParam } from './useParams';
import { hasAuthToken, isRouteProtected } from '@/utils/utils';

/**
 * Route guard hook that prevents access to protected routes without authentication
 * Automatically redirects to login if token is missing or invalid
 */
export const useRouteGuard = () => {
  const { router: { replace, pathname } } = useRouterParam();

  useEffect(() => {
    const isProtected = isRouteProtected(pathname);
    const hasValidToken = hasAuthToken();

    // If route is protected but user has no token, redirect to login
    if (isProtected && !hasValidToken) {
      replace('/login');
    }
  }, [replace, pathname]);
};
